import { PipeTransform, Pipe } from '@angular/core';
import isString from 'lodash-es/isString';

/**
 * new line to br pipe
 *
 * If there is new line we put br there
 */
@Pipe({
    name: 'nl2br',
    standalone: true
})
export class Nl2brPipe implements PipeTransform {
    transform = nl2br;
}

export function nl2br(input: string): string | number | undefined {
    if (!input || !isString(input)) {
        return input;
    }

    return input.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
}
